import { c as _c } from "react/compiler-runtime";
import { AppLayout } from '@src/components/sco/AppLayout';
import { FundingLandingSection } from '@src/components/sco/Funding/sections/FundingLandingSection';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { HubspotHideChatStyles } from '@src/components/sco/utilities/HubspotChatHandler/HubspotHideChatStyles';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';

/**
 * Marketing landing in a single-panel AppLayout.
 * Used for guests / no-search users on /funding and always on /funding/landing.
 */
export const FundingLandingLayout = t0 => {
  const $ = _c(7);
  const {
    skipRedirect: t1
  } = t0;
  const skipRedirect = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HubspotHideChatStyles />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScoSiteNavBar />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== skipRedirect) {
    t4 = <FundingLandingSection skipRedirect={skipRedirect} />;
    $[2] = skipRedirect;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      bgColor: "colorPalette.panel"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <SSRGate disableSSR={true}>{t2}<AppLayout header={t3} id="funding-landing" panels={[{
        id: "funding-landing-main",
        children: t4,
        containerProps: t5
      }]} /></SSRGate>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};